import { Divider as AntDivider, type DividerProps as AntDividerProps } from 'antd'
import type { ReactNode } from 'react'

export type DividerProps = Omit<AntDividerProps, 'plain' | 'children' | 'size'> &
  (
    | {
        children?: ReactNode
        size?: never
        label?: never
      }
    | {
        label?: ReactNode
        size?: 'default' | 'large'
        children?: never
      }
  )

export const Divider = ({ size = 'default', label, children, ...props }: DividerProps) => {
  return (
    <AntDivider
      {...props}
      plain={size === 'default'}
      className={`${label ? 'ant-divider-tag' : ''} ${props.className ?? ''}`}
    >
      {label ?? children}
    </AntDivider>
  )
}
